import { createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-1a3a48b8"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "loading"
};
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"logo\" data-v-1a3a48b8></div><div id=\"loading-center-absolute\" data-v-1a3a48b8><div class=\"object\" id=\"object_one\" data-v-1a3a48b8></div><div class=\"object\" id=\"object_two\" style=\"left:8px;\" data-v-1a3a48b8></div><div class=\"object\" id=\"object_three\" style=\"left:16px;\" data-v-1a3a48b8></div><div class=\"object\" id=\"object_four\" style=\"left:24px;\" data-v-1a3a48b8></div><div class=\"object\" id=\"object_five\" style=\"left:32px;\" data-v-1a3a48b8></div></div>", 2);
const _hoisted_4 = [_hoisted_2];
export default {
  __name: 'Loading',
  setup(__props) {
    // const logo = require("@/assets/logo.png");

    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_4);
    };
  }
};